import React, { useState } from "react";
import "../../styles/SummaryCard.css";

export default function SummaryCard({ title, value, hasDropdown }) {
  const [dropdownValue, setDropdownValue] = useState("Today");
  const dropdownOptions = [
    "Today",
    "Last 7 Days",
    "Last 30 Days",
    "Current Week",
    "Current Month",
    "Total"
  ];

  return (
    <div className="summary-card">
      <div className="summary-header">
        <span className="summary-title top-left">{title}</span>
        {hasDropdown && (
          <select
            className="summary-dropdown"
            value={dropdownValue}
            onChange={(e) => setDropdownValue(e.target.value)}
          >
            {dropdownOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="summary-value bottom-left">{value}</div>
    </div>
  );
}

